const AttendanceHistoryType = Object.freeze({
  NoShow: 0,
  RevokeNoShow: 1,
  Suspended: 2,
  Reactivated: 3
})

export {
  AttendanceHistoryType
}
